import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { routes } from "app/routes";
import { InfoPopup } from "components/InfoPopup";
import { push } from "connected-react-router";
import { LandingTwoColumnLayout } from "features/landingPage/FunnelMVP/LandingTwoColumnLayout";
import MembershipChargeExplanationPopup from "features/landingPage/MembershipChargeExplanationPopup";
import generosityOutline from "images/generosity-outline.svg";
import { useDispatch } from "react-redux";
import { UpdateLegacyBillingCloseIcon } from "./UpdateLegacyBillingCloseIcon";

const useStyles = makeStyles((theme) => ({
    videoColumn: {
        width: "40%",
        [theme.breakpoints.down("md")]: {
            position: "relative",
            // margin: "5%",
            width: "100%",
        },
    },
    contentWrapper: {
        width: "60%",
        marginLeft: "40%",
        paddingRight: theme.spacing(15),
        [theme.breakpoints.down("md")]: {
            minHeight: "unset",
            marginLeft: "0",
            width: "100%",
            padding: theme.spacing(8),
        },
    },
    image: {
        [theme.breakpoints.down("md")]: {
            display: "none",
        },
    },
    info: {
        marginBottom: theme.spacing(15),
    },
}));

export const UpdateLegacyBillingPage2 = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    return (
        <>
            <UpdateLegacyBillingCloseIcon />
            <LandingTwoColumnLayout
                continueButtonText="Choose contribution"
                classes={{
                    // container: classes.container,
                    videoColumn: classes.videoColumn,
                    // video: classes.video,
                    contentWrapper: classes.contentWrapper,
                }}
                onNext={() => {
                    dispatch(push(routes.memberUpdateLegacyBillingPage3()));
                }}
                content={
                    <div className={classes.info}>
                        <div className={classes.image}>
                            <img src={generosityOutline} alt="" />
                        </div>

                        <Typography variant="h4" data-testid="payWhatYouCanTitle">
                            Let’s start with choosing your base contribution.{" "}
                        </Typography>
                        <Typography variant="body1">
                            We ask that you make a sincere contribution of what you can afford.
                        </Typography>
                        <Typography variant="body1">
                            This allows us to open our community to those who need support, and pay
                            your teachers fairly.
                        </Typography>
                        <InfoPopup
                            linkText="How is my contribution used?"
                            amplitudeEventId="payWhatYouCanPageFeeExplanation"
                            hideInfoIcon={true}
                        >
                            <MembershipChargeExplanationPopup />
                        </InfoPopup>
                    </div>
                }
                videoUrl="https://storage.googleapis.com/cloud-sangha-images/funnel-experiment-videos/Sky.mp4"
                videoId="slidingScaleExplanation"
            />{" "}
        </>
    );
};
